import React, { ChangeEvent } from 'react';
import TextInput from './TextInput';
import PasswordInput from './PasswordInput';
import EmailInput from './EmailInput';
import SelectInput from './SelectInput'; 

interface UserFormProps {
  nome: string;
  setNome: (v: string) => void;

  senha: string;
  setSenha: (v: string) => void;

  currentPassword?: string;
  setCurrentPassword?: (v: string) => void;

  email: string;
  setEmail: (v: string) => void;

  empresa: string;
  setEmpresa: (v: string) => void;

  cargo: string;
  setCargo: (v: string) => void;

  role: 'funcionario' | 'admin';
  children?: React.ReactNode;
}

const cargosDisponiveis = ['ADMIN', 'MEMBRO'];

export default function UserForm({
  nome, setNome,
  senha, setSenha,
  currentPassword, setCurrentPassword,
  email, setEmail,
  empresa, setEmpresa,
  cargo, setCargo,
  role,
  children,
}: UserFormProps) {

  return (
    <>
      <div className="form-container"> 
        <TextInput
          label="Nome"
          value={nome}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setNome(e.target.value)}
        />

        <EmailInput
          label="E-mail"
          value={email}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
        />

        {/* Senha nova */}
        <PasswordInput
          label="Senha"
          value={senha}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setSenha(e.target.value)}
        />

        {/* Senha atual apenas para admin alterar o próprio perfil */}
        {role === 'admin' && setCurrentPassword && (
          <PasswordInput
            label="Senha atual"
            value={currentPassword}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setCurrentPassword(e.target.value)
            }
          />
        )}

        <TextInput
          label="Empresa"
          value={empresa}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setEmpresa(e.target.value)}
          disabled={true}
        />

        <SelectInput
          label="Cargo/Função"
          value={cargo}
          onChange={setCargo}
          options={cargosDisponiveis}
          disabled={role === 'funcionario'}
        />
      </div>

      {children && <div className="form-extra">{children}</div>}
    </>
  );
}
